import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faFacebookSquare, faTwitterSquare, faInstagramSquare, faWhatsapp } from '@fortawesome/free-brands-svg-icons'

// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/custom.scss'

import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'

library.add(faFacebookSquare)
library.add(faWhatsapp)
library.add(faTwitterSquare)
library.add(faInstagramSquare)
library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-Store-Id': process.env.VUE_APP_STORE_ID
  }
})

axiosInstance.interceptors.request.use((config) => {
  const user = store.state.user
  if (user) {
    config.headers.Authorization = `Bearer ${user.jwt}`
  }
  return config
})

Vue.use(VueAxios, axiosInstance)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.filter('toCurrency', (value) => {
  if (typeof value !== 'number') return value

  const formatter = new Intl.NumberFormat('es-MX', {
    currencyDisplay: 'symbol',
    style: 'currency',
    currency: 'MXN'
  })
  return formatter.format(value)
})

Vue.filter('truncate', (text, size, clamp) => {
  return text.slice(0, size) + (size < text.length ? clamp || '...' : '')
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
